import { commonUtil } from '@/util'

const request = {}

request.createRequest = function (suggestedReceivingLocationData) {
  return {
    location: suggestedReceivingLocationData.location,
    phoneNumberCountryId:
      suggestedReceivingLocationData.phone.countryCode.value,
    phoneNumber: suggestedReceivingLocationData.phone.phoneNumber,
    addressCountryId: suggestedReceivingLocationData.country.value,
    postalCode: suggestedReceivingLocationData.postalCode
      ? suggestedReceivingLocationData.postalCode
      : null,
    regionId: commonUtil.nullEmptyFormatNull(
      commonUtil.formatRegion(suggestedReceivingLocationData.region, true)
    ),
    region: commonUtil.nullEmptyFormatNull(
      commonUtil.formatRegion(suggestedReceivingLocationData.region, false)
    ),
    address1: suggestedReceivingLocationData.address1,
    address2: suggestedReceivingLocationData.address2
      ? suggestedReceivingLocationData.address2
      : null,
    sortNumber: suggestedReceivingLocationData.sortNumber
  }
}
export default { request }
